const images = Array.from({length: 13}, (_, i) => `${String(i + 1).padStart(3, '0')}.png`);

export default images;